import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/api";
import TreatmentPlanReadOnly from "@/components/clinical/TreatmentPlanReadOnly";

export default function TreatmentPlanTab({ patientId, editPath }) {
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPlan = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/patients/${patientId}/treatment-plan`);
      setPlan(data?.exists ? data.plan : null);
    } catch {
      setPlan(null);
    } finally {
      setLoading(false);
    }
  }, [patientId]);

  useEffect(() => { fetchPlan(); }, [fetchPlan]);

  if (loading) {
    return <div className="text-sm text-slate-400 p-4" data-testid="treatment-plan-loading">Chargement du plan de traitement…</div>;
  }
  return (
    <div className="dash-card" data-testid="treatment-plan-tab">
      <TreatmentPlanReadOnly plan={plan} onEditRedirect={() => navigate(editPath)} />
    </div>
  );
}
